<template>
  <News code="foundry_quotation" />
</template>
<script>
import News from "./news.vue";

export default {
  name: "About",
  components: {
    News,
  },
  data() {
    return {
      pageData: {},
    };
  },
  created() {},
  methods: {},
};
</script>
